import { io, Socket } from 'socket.io-client';
import { SOCKET_EVENTS } from '@maios/shared';
import { useAuthStore } from '../store/authStore';

let socket: Socket | null = null;
let tokenUnsubscribe: (() => void) | null = null;

export function getSocket(): Socket | null {
  return socket;
}

export function connectSocket(): Socket {
  if (socket?.connected) return socket;

  const token = useAuthStore.getState().accessToken;

  socket = io('/', {
    auth: { token },
    transports: ['websocket', 'polling'],
    autoConnect: true,
  });

  socket.on('connect', () => {
    console.info('[Socket] Connected:', socket?.id);
  });

  socket.on('connect_error', (err) => {
    console.warn('[Socket] Connection error:', err.message);
    // 인증 실패 시 → 스토어에서 최신 토큰으로 갱신 후 재연결 시도
    const freshToken = useAuthStore.getState().accessToken;
    if (socket && freshToken) {
      socket.auth = { token: freshToken };
    }
  });

  socket.on('disconnect', (reason) => {
    console.info('[Socket] Disconnected:', reason);
  });

  // 토큰 갱신 시 소켓 auth도 자동 업데이트
  if (tokenUnsubscribe) tokenUnsubscribe();
  tokenUnsubscribe = useAuthStore.subscribe((state, prevState) => {
    if (socket && state.accessToken && state.accessToken !== prevState.accessToken) {
      socket.auth = { token: state.accessToken };
      // 연결이 끊어진 상태면 새 토큰으로 재연결
      if (!socket.connected) {
        socket.connect();
      }
    }
  });

  return socket;
}

export function disconnectSocket() {
  if (tokenUnsubscribe) {
    tokenUnsubscribe();
    tokenUnsubscribe = null;
  }
  if (socket) {
    socket.disconnect();
    socket = null;
  }
}

export function joinProject(projectId: string) {
  socket?.emit(SOCKET_EVENTS.JOIN_PROJECT, projectId);
}

export function leaveProject(projectId: string) {
  socket?.emit(SOCKET_EVENTS.LEAVE_PROJECT, projectId);
}

export { SOCKET_EVENTS };
